module.exports = __webpack_public_path__ + "static/media/discovery_area.1d4d5157.svg";